<template>
  <div>
    <!-- <PageHead title="到期提醒设置"></PageHead> -->
    <PageHead title="提醒设置"></PageHead>
    <div class="oa-layout-content">
      <!-- <a-tabs :default-active-key="tobIt" @change="callback">
        <a-tab-pane key="1" tab="人事管理" />
        <a-tab-pane key="2" tab="基础信息管理" />
      </a-tabs> -->

      <div class="mb20" v-for="(item, index) in timingList" :key="index">
        {{ index + 1 }}.{{ item.name }}到期前
        <a-input-number v-model="item.timingDay" :min="0" :max="100000000" />
        天，发系统消息提醒。
      </div>

      <a-button
        style="margin-left: 120px"
        type="primary"
        @click="submitForm()"
        :loading="loading"
      >
        确认
      </a-button>
      <a-button style="margin-left: 30px" @click="load()"> 取消 </a-button>
    </div>

    <appfloor></appfloor>
  </div>
</template>

<script>
import { gettiming, updatetiming } from './api/api'
export default {
  data() {
    return {
      tobIt: '1',
      value: '30',
      timingList: [],
      loading: false
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      gettiming().then((res) => {
        if (res.data.code == 0) {
          this.timingList = res.data.data.timings
        }
      })
    },
    submitForm() {
      this.loading = true
      updatetiming(this.timingList).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.$message.success('修改成功！')
          this.load()
        }
      })
    },
    callback(key) {
      this.tobIt = key
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/system/RemindSet.vue